import CaseAppealsOrdersTable from "./components/caseAppealsOrdersTable";

/**
 * Case Appeals page — mirrors Oncology Submission table for pharma oncology appeals.
 */
const PharmaOncologyAppealsTable = () => {
  return (
    <div className="pharma_submission__layout h-full w-full bg-primaryGray-16 p-2">
      <div className="pharma_summary__inner-container flex h-full flex-col gap-2 overflow-hidden rounded bg-white p-4">
        <div className="pharma_submission__heading text-h11 font-bold">
          Case Appeals
        </div>
        <div className="pharma_submission__table-container flex-1 overflow-auto">
          <CaseAppealsOrdersTable />
        </div>
      </div>
    </div>
  );
};

export default PharmaOncologyAppealsTable;
